import style from './info-block.module.scss';
import Image from 'next/image'
import checkIcon from '/public/givingli-images/icons/icn_check.png'
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss';

const InfoBlock = (props: any) => {
    let { state } = props;
    return (
        <>
            <InView triggerOnce={true}>
                {({ inView, ref, entry }) => {
                    if (inView) {
                        entry?.target.classList.add(animations.active);
                    }
                    return (
                        <div ref={ref} className={`${style.info__block} ${animations.scroll__animation}`}>
                            <div className={style.info__sticker__block}>
                                <div className={`${style.info__sticker} `}>
                                    <Image alt="sticker" src={state.sticker} layout={'fill'} sizes="400px" />
                                </div>
                            </div>
                            <div className={style.info__content}>
                                <div className={style.info__title}>
                                    {state.title}
                                </div>
                                <div className={style.info__text}>
                                    {state.textPoints.map((item: any, index: number) => {
                                        return <div className={style.info__text__item} key={index}>
                                            <div className={style.info__text__item__image}>
                                                <Image sizes="24px" alt="checkIcon" src={checkIcon} layout={'fill'} />
                                            </div>
                                            <div className={style.info__text__item__text}>
                                                {item}
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    )
                }}
            </InView>
        </>
    )
}

export default InfoBlock;
